module.exports = __webpack_public_path__ + "assets/img/warrior-name-b92a8c08.png";